import { render, staticRenderFns } from "./SolicitudesAlumno.vue?vue&type=template&id=508277c9&"
import script from "./SolicitudesAlumno.vue?vue&type=script&lang=js&"
export * from "./SolicitudesAlumno.vue?vue&type=script&lang=js&"
import style0 from "./SolicitudesAlumno.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports